import { httpClient } from "../http/httpClient";

export interface HandleDocumentsParams {
  id: string;
  files: File[];
  removeFiles: string[];
}

export const handleTransactionDocuments = async ({ id, files, removeFiles }: HandleDocumentsParams) => {
  const formData = new FormData();

  files.forEach((file: File) => {
    formData.append("files", file);
  });

  if (removeFiles.length > 0) {
    formData.append("removeFiles", JSON.stringify(removeFiles));
  }
  
  const response = await httpClient.post(`/transaction/${id}/documents`, formData).catch((err) => {
    throw err?.response?.data || err;
  });
  return response.data;
};